import React from "react";
import { WebinarCandidate } from "./WebinarCandidatesList";
import { ViewCandidateDetailDialog } from "./ViewCandidateDetailDialog";

interface Props {
  candidates: WebinarCandidate[];
  selectedCandidates: Set<string>;
  toggleCandidateSelection: (id: string) => void;
  toggleAllCandidates: () => void;
  copyDetails: (candidate: WebinarCandidate) => void;
}

export const CandidatesTable = ({
  candidates,
  selectedCandidates,
  toggleCandidateSelection,
  toggleAllCandidates,
  copyDetails,
}: Props) => {
  return (
    <table className="table">
      <thead className="text-[14px] font-semibold bg-base-200">
        <tr>
          <th>
            <input
              type="checkbox"
              className="checkbox checkbox-sm"
              checked={
                candidates.length > 0 &&
                selectedCandidates.size === candidates.length
              }
              onChange={toggleAllCandidates}
            />
          </th>
          <th>Name</th>
          <th className="text-center">Contact Number</th>
          <th className="text-center">WhatsApp</th>
          <th className="text-center">Email</th>
          <th className="text-center">State</th>
          <th>Date of Reg.</th>
          <th className="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        {candidates.length === 0 ? (
          <tr>
            <td colSpan={10} className="text-center text-gray-500 py-8">
              No candidates found
            </td>
          </tr>
        ) : (
          candidates.map((candidate) => (
            <tr key={candidate.id}>
              <td>
                <input
                  type="checkbox"
                  className="checkbox checkbox-sm"
                  checked={selectedCandidates.has(
                    candidate.id || candidate.email,
                  )}
                  onChange={() =>
                    toggleCandidateSelection(candidate.id || candidate.email)
                  }
                />
              </td>
              <td className="font-medium capitalize">{candidate.name}</td>
              <td className="text-center">{candidate.phone_number}</td>
              <td className="text-center">{candidate.whatsapp_number || "-"}</td>
              <td className="text-center">{candidate.email}</td>
              <td className="capitalize text-center">
                <p>{candidate.state}</p>
                <span className="text-sm px-2 rounded-lg bg-slate-200">{candidate.district}</span>
              </td>
              <td>{new Date(candidate.created_at).toLocaleDateString()}</td>
              <td>
                <div className="flex gap-2 justify-end">
                  <button
                    onClick={() => copyDetails(candidate)}
                    className="rounded-md border border-gray-400 px-2 py-1 hover:bg-slate-300"
                  >
                    Copy
                  </button>
                  <ViewCandidateDetailDialog candidate={candidate}>
                    <button className="rounded-md border border-gray-400 px-2 py-1 hover:bg-slate-300">Detail</button>
                  </ViewCandidateDetailDialog>
                </div>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};
